<template>
    <div class="order-wrapper">
        <ctl-coach-header title="陪驾订单列表" left-arrow :onBack="onBack"/>
            <van-search
                v-model="keyword"
                :left-icon="require('@/assets/peijia/icon_search_b.png')"
                :clearable="false"
                placeholder="请输入学员姓名、手机号码、订单号"
            />
            <van-tabs v-model="active"
                      animated
                      background="#FAFAFA"
                      color="#53CB85"
                      style="background: #FAFAFA"
                      title-active-color="#53CB85"
            >
                <van-tab title="全部" name=""></van-tab>
                <van-tab name="2">
                    <template slot="title">待分配 <b class="num">{{ orderCount.status2 }}</b></template>
                </van-tab>
                <van-tab name="3">
                    <template slot="title">已分配 <b class="num">{{ orderCount.status3 }}</b></template>
                </van-tab>
                <van-tab name="4">
                    <template slot="title">已完成 <b class="num">{{ orderCount.status4 }}</b></template>
                </van-tab>
                <van-tab name="5">
                    <template slot="title">退款中 <b class="num">{{ orderCount.status5 }}</b></template>
                </van-tab>
                <van-tab name="7">
                    <template slot="title">退款成功 <b class="num">{{ orderCount.status7 }}</b></template>
                </van-tab>
                <van-tab name="8">
                    <template slot="title">退款失败 <b class="num">{{ orderCount.status8 }}</b></template>
                </van-tab>
            </van-tabs>
            <van-pull-refresh v-model="refreshLoading" @refresh="()=>{this.getList(1);this.getPJOrderCount(1)}">
                <!-- 列表 -->
                <van-list
                    v-if="orderList.length > 0"
                    v-model="loading"
                    :error-text="'请求失败， 点击重新加载'"
                    :error.sync="error"
                    :finished="finished"
                    @load="getList"
                    finished-text="没有更多了"
                >
                    <div v-for="(v, i) in orderList" :key="i" class="card" @click="goDetail(v)">

                        <div class="card-top">
                            <div class="item">下单日期：{{v.orderTime}}</div>
                            <div class="item">订单编号：{{v.orderNo}}</div>
                            <div class="item">学员姓名：{{v.userName}}</div>
                            <div class="item" @click.stop="callPhone(v)">学员手机号码：{{v.userMobile}}</div>
                            <div class="item" v-if="v.coachName">陪驾教练：{{v.coachName}}</div>
                        </div>
                        <div class="card-main">
                            <div class="main-left">
                                <img :src="v.imgUrl" alt="">
                            </div>
                            <div class="main-right">
                                <div class="title">{{v.goodsName}}</div>
                                <div class="tab">{{v.goodsPriceCartModel}}</div>
                                <div class="price">￥{{v.goodsSalePrice}}/{{v.hours}}</div>
                                <div class="remark">{{v.remark}}</div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="btn btn-refund" v-if="v.showRefundBtn" @click.stop="refund(v)">申请退款</div>
                            <div class="btn btn-refund" v-if="v.showDispatchBtn" @click.stop="dispatch(v)">分配订单</div>
                            <div class="btn btn-refund" v-if="v.showFinishBtn" @click.stop="finish(v)">完成订单</div>
                        </div>
                        <div class="flag">
                            <img v-if="v.orderStatus === 2" src="@/assets/peijia/icon_dfp.png" alt="">
                            <img v-if="v.orderStatus === 3" src="@/assets/peijia/icon_yfp.png" alt="">
                            <img v-if="v.orderStatus === 7" src="@/assets/peijia/icon_tkcg.png" alt="">
                            <img v-if="v.orderStatus === 8" src="@/assets/peijia/icon_tksb.png" alt="">
                            <img v-if="v.orderStatus === 5" src="@/assets/peijia/icon_tkz.png" alt="">
                            <img v-if="v.orderStatus === 6" src="@/assets/peijia/icon_tkz.png" alt="">
                            <img v-if="v.orderStatus === 4" src="@/assets/peijia/icon_ywc.png" alt="">
                        </div>
                    </div>
                </van-list>
                <div v-else class="empty"><img src="@/assets/peijia/icon_wpjdd.png" alt="">暂无数据</div>
            </van-pull-refresh>
            <ctl-dialog v-model="dialogDataRefund" class="refund-dialog">
                <div slot="content" class="content">
                    <div class="item">
                        <div class="label">退款方式：</div>
                        <div class="value">全额退款</div>
                    </div>
                    <div class="item textarea">
                        <div class="label">备注：</div>
                        <div class="value">
                            <van-field
                                v-model="otherReason"
                                rows="4"
                                maxlength="50"
                                type="textarea"
                                placeholder="请输入退款原因"
                            />
                        </div>
                    </div>
                </div>
            </ctl-dialog>
            <ctl-dialog v-model="dialogDataDispatch" class="dispatch-dialog">
                <div slot="content" class="content">
                    <van-search
                        v-model="keywordCoach"
                        :left-icon="require('@/assets/peijia/icon_search_b.png')"
                        :clearable="false"
                        placeholder="请输入教练姓名、手机号码"
                        @search="onSearchCoach"
                    />
                    <div class="card-title">
                        <div class="item">序号</div>
                        <div class="item">教练姓名</div>
                        <div class="item">联系方式</div>
                    </div>
                    <van-list
                        v-if="coachList.length > 0"
                        v-model="loadingCoach"
                        :error-text="'请求失败， 点击重新加载'"
                        :error.sync="errorCoach"
                        :finished="finishedCoach"
                        @load="getCoachList"
                        finished-text="没有更多了"
                    >
                        <div v-for="(v, i) in coachList" :key="i" :class="['card',coachCurrentId === v.id && 'active']" @click="coachCurrentId = v.id">
                            <div class="item">{{i+1}}</div>
                            <div class="item">{{v.coachName}}</div>
                            <div class="item">{{v.phoneNum}}</div>
                        </div>
                    </van-list>
                </div>
            </ctl-dialog>
        </div>
</template>
<script>
import { Tab, Tabs, Sticky, Search, Toast, PullRefresh, List, Field, Dialog } from 'vant'
import dialog from '@/components/dialog/index.vue'

export default {
    name: 'order',
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Search.name]: Search,
        [PullRefresh.name]: PullRefresh,
        [List.name]: List,
        [Field.name]: Field,
        ctlDialog: dialog,
        [Sticky.name]: Sticky
    },
    data () {
        return {
            active: '',
            source: '',
            pageData: {
                current: 1,
                size: 10
            },
            // 弹窗数据
            dialogDataRefund: {
                visible: false,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 弹窗数据
            dialogDataDispatch: {
                visible: false,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            orderList: '',
            orderCount: {},
            loading: false,
            error: false,
            finished: false,
            refreshLoading: false,
            headShow: '',
            otherReason: '',
            keyword: '',

            loadingCoach: false,
            errorCoach: false,
            finishedCoach: false,
            keywordCoach: '',
            coachList: '',
            serviceProviderId: '',
            coachCurrentId: '',
            pageDataCoach: {
                current: 1,
                size: 10
            }
        }
    },
    created () {
        this.getPJOrderCount()
        this.getList(1)
    },
    watch: {
        active: {
            handler () {
                this.getList(1)
            },
            deep: true
        },
        keyword: {
            handler () {
                this.onSearch()
            },
            deep: true
        },
        keywordCoach: {
            handler () {
                this.onSearchCoach()
            },
            deep: true
        }
    },
    mounted () {
        setTimeout(() => {
            this.active = localStorage.getItem('peijia-order-tab-index') || ''
        }, 200)
    },
    methods: {
        // 搜索
        onSearch () {
            this.getList(1)
            this.getPJOrderCount(1)
        },
        // 返回
        onBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 搜索教练
        onSearchCoach () {
            this.getCoachList(1)
        },
        // 拨打手机号
        callPhone (v) {
            this.$jsBridge.callBackHandler('callPhone', { tel: v.userMobile })
        },
        // 退款
        refund (v) {
            this.otherReason = ''
            this.dialogDataRefund.leftBtnMethod = () => {
                this.dialogDataRefund.visible = false
            }
            this.dialogDataRefund.rightBtnMethod = () => {
                this.$api.refundProvider({
                    isAll: true,
                    orderId: v.id,
                    otherReason: this.otherReason
                }).then(res => {
                    Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                    if (res.status) {
                        Toast.clear()
                        this.getPJOrderCount(1)
                        this.getList(1)
                        this.dialogDataRefund.visible = false
                        Dialog.confirm({
                            title: '提示',
                            message: '您的退款申请已提交，请等待斑斑客服处理！',
                            confirmButtonText: '我知道了',
                            showCancelButton: false
                        })
                    } else {
                        Toast(res.message)
                    }
                })
            }
            this.dialogDataRefund.title = '申请退款'
            this.dialogDataRefund.visible = true
        },
        // 分配订单
        dispatch (v) {
            this.serviceProviderId = v.providerId
            this.coachCurrentId = ''
            this.getCoachList(1)
            this.dialogDataDispatch.visible = true
            this.dialogDataDispatch.leftBtnMethod = () => {
                this.dialogDataDispatch.visible = false
            }
            this.dialogDataDispatch.rightBtnMethod = () => {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.dispatchProvider({
                    coachId: this.coachCurrentId,
                    ids: [v.id],
                    terminalType: 2
                }).then(res => {
                    if (res.status) {
                        this.getPJOrderCount(1)
                        this.getList(1)
                        this.dialogDataDispatch.visible = false
                        Toast('订单分配成功！')
                    } else {
                        Toast(res.message)
                    }
                })
            }
        },
        // 完成订单
        finish (v) {
            Dialog.confirm({
                title: '提示',
                message: '该学员陪驾服务是否已全部完成？'
            }).then(() => {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.finishProvider({
                    ids: [v.id],
                    terminalType: 2
                }).then(res => {
                    Toast.clear()
                    if (res.status) {
                        this.getPJOrderCount(1)
                        this.getList(1)
                    } else {
                        Toast(res.message)
                    }
                })
            })
        },
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 跳转详情
        goDetail (v) {
            localStorage.setItem('peijia-order-tab-index', this.active)
            this.$router.push({ name: 'peijiaCoachOrderDetail', query: { id: v.id } })
        },
        // 获取数据
        getList (refresh) {
            if (refresh) {
                this.pageData.current = 1
            }
            const postData = Object.assign({ orderStatus: this.active ? this.active : '', keyword: this.keyword }, this.pageData)
            this.$api.getPJOrderList(postData).then(res => {
                this.error = false
                if (res.status) {
                    if (refresh) {
                        this.orderList = res.result.records.map(item => {
                            item.orderTime = this.moment.formatTime(item.orderTime, 'YYYY-MM-DD HH:mm:ss')
                            return item
                        })
                    } else {
                        res.result.records.map(item => {
                            item.orderTime = this.moment.formatTime(item.orderTime, 'YYYY-MM-DD HH:mm:ss')
                            this.orderList.push(item)
                        })
                    }
                    this.pageData.current++
                    this.finished = res.result.records.length < this.pageData.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.error = true
                }
                this.refreshLoading = false
                this.loading = false
            })
        },
        // 获取表格统计
        getPJOrderCount (refresh) {
            if (refresh) {
                this.pageData.current = 1
            }
            const postData = Object.assign({ orderStatus: '', keyword: this.keyword }, this.pageData)
            this.$api.getPJOrderCount(postData).then(res => {
                if (res.status) {
                    this.orderCount = res.result
                }
            })
        },
        // 获取教练数据
        getCoachList (refresh) {
            if (refresh) {
                this.pageDataCoach.current = 1
            }
            const postData = Object.assign({ query: this.keywordCoach, serviceProviderId: this.serviceProviderId }, this.pageDataCoach)
            this.$api.dispatchCoachList(postData).then(res => {
                this.errorCoach = false
                if (res.status) {
                    if (refresh) {
                        this.coachList = res.result.records
                    } else {
                        this.coachList.push(...res.result.records)
                    }
                    this.pageDataCoach.current++
                    this.finishedCoach = res.result.records.length < this.pageDataCoach.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.errorCoach = true
                }
                this.loadingCoach = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.van-list{
    padding: 0 15px;
}
.dispatch-dialog{
    .van-list{
        padding: 0;
        height: 300px;
        overflow: auto;
    }
    .van-search{
        width: 270px;
        border-radius: 20px;
        border: 1px solid #E6E6E6;
        /deep/ {
            .van-search__content{

            }
            .van-cell{
                line-height: 1;
            }
        }
    }
    .card-title{
        width: 270px;
        margin: 10px auto 0;
        .item{
            display: inline-block;
            text-align: center;
            font-size: 15px;
            font-weight: 600;
            color: #333333;
        }
        .item:nth-child(1){
            width: 55px;
        }
        .item:nth-child(2){
            width: 80px;
        }
        .item:nth-child(3){
            width: 130px;
        }
    }
    .van-list{
        margin: 17px 0 0 0;
        .card{
            padding: 8px 0;
            width: 270px;
            display: flex;
            justify-content: space-around;
            margin: 0 auto 7px;
            border: 1px solid #ffffff;
        }
        .item{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            text-align: center;
            font-size: 15px;
            color: #333333;
        }
        .item:nth-child(1){
            width: 55px;
        }
        .item:nth-child(2){
            width: 80px;
        }
        .item:nth-child(3){
            width: 130px;
        }
        .active{
            position: relative;
            background: #F5FFFB;
            border-radius: 5px;
            border: 1px solid #00CA84;
            &::after{
                position: absolute;
                bottom: -1px;
                right: -1px;
                content: ' ';
                width: 16px;
                height: 14px;
                background: url("~@/assets/peijia/icon_jlgx.png") no-repeat 100%/100%;
            }
        }
    }
}
.refund-dialog{
    .content{
        margin: 15px 0 0 0;
    }
    .item{
        display: flex;
        align-items: center;
        padding: 0 15px;
        .label{
            font-size: 15px;
            font-weight: 600;
            color: #333333;
        }
        .value{
            font-size: 15px;
            font-weight: 400;
            color: #333333;
        }
    }
    .textarea{
        margin: 13px 0 0 0;
        flex-direction: column;
        align-items: flex-start;
        /deep/ {
            .van-cell{
                padding: 5px 10px;
            }
        }
        .value{
            overflow: hidden;
            margin: 10px 0 0 0;
            width: 100%;
            height: 100px;
            border-radius: 5px;
            border: 1px solid #E6E6E6;
        }
    }
}
.card{
    box-sizing: border-box;
    position: relative;
    width: 345px;
    padding: 15px 15px 10px;
    background: #FFFFFF;
    border-radius: 5px;
    line-height: 1;
    .card-top{
        .item{
            margin: 0 0 10px 0;
            font-size: 14px;
            color: #333333;
        }
    }
    .card-main{
        padding: 10px 0;
        border-top: 1px solid #EBECF4;
        border-bottom: 1px solid #EBECF4;
        display: flex;
        .main-left{
            img{
                width: 100px;
                height: 100px;
            }
        }
        .main-right{
            flex: 1;
            margin: 0 0 0 15px;
            .title{
                margin: 5px 0 0 0;
                font-size: 15px;
                font-weight: 600;
                color: #333333;
            }
            .tab{
                margin: 10px 0 0 0;
                display: inline-block;
                padding: 4px 13px;
                border-radius: 3px;
                border: 1px solid #666666;
                font-size: 12px;
                color: #666666;
            }
            .price{
                margin: 10px 0 0 0;
                font-size: 14px;
                color: #666666;
            }
            .remark{
                margin: 10px 0 0 0;
                font-size: 12px;
                color: #666666;
            }
        }
    }
    .card-footer{
        display: flex;
        justify-content: flex-end;
        margin: 10px 0 0 0;
        .btn{
            background: #00CA84;
            border-radius: 16px;
            font-size: 15px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 90px;
            height: 30px;
        }
        .btn + .btn{
            margin: 0 0 0 10px;
        }
    }
    .flag{
        position: absolute;
        right: 0;
        top: 0;
        img{
            width: 47px;
        }
    }
}
.card + .card{
    margin:  10px 0 0 0 ;
}
.order-wrapper {
    background-color: #F3F4FB;
    height: 100%;
    flex-direction: column;
    display: flex;
}
.van-search{
    width: 345px;
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 20px;
    /deep/ {
        .van-search__content{
            background: #ffffff;
            .van-cell{
                padding: 0;
            }
            .van-cell__value{
                margin: 0 0 0 8px;
            }
        }
    }
}
.van-tabs{
    padding: 0 15px;
    background: #F3F4FB !important;
    margin: 15px 0 0 0;
    /deep/ {
        .van-tabs__wrap{
            height: auto;
        }
        .van-tab{
            padding: 0 0 5px;
        }
        .van-tabs__nav{
            background: #F3F4FB !important;
        }
        .van-tab__text{
            color: #333333 !important;
            font-size: 14px;
        }
        .van-tab+.van-tab{
            margin: 0 0 0 20px;
        }
        .van-tabs__line{
            width: 20px;
        }

        .num{
            margin: 0 0 0 2px;
            color: #FE4A48;
            font-weight: 400;
        }
        .van-tab--active{
            font-weight: 600;
            color: #333333 !important;
            .num{
                font-weight: 600;
            }
        }
    }
}
.van-pull-refresh{
    overflow: auto;
    flex: 1;
}
.empty{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 100px 0 0 0;
    font-size: 15px;
    font-weight: 400;
    color: #999999;
    img{
        width: 100px;
    }
}
</style>
